import { useRoutes } from "react-router-dom";
import Layout from "../components/layouts/Layout";
import Home from "../pages/home/Home";
import Store from "../pages/store/Store";
import StoreAll from "../pages/store/StoreAll";
import Preview from "../pages/store/Preview";
import Detail from "../pages/store/Detail";
import Knowledge from "../pages/knowledge/Knowledge";
import Contact from "../pages/contact/Contact";
import About from "../pages/Abouts/About";
import WebsiteDesign from "../pages/services/WebsiteDesign";
import NotFound from "../pages/NotFound/NotFound";

// All routes are statically imported. React.lazy() + <Suspense> + react-snap
// pre-render + React 19 strict hydration produce error #418 because every lazy
// chunk's Promise resolves on a microtask, and React reaches the Suspense
// boundary before that microtask runs — even when the chunk is already loaded
// in webpack's module cache. We tried webpackPreload, webpackMode: "eager", and
// awaiting Promise.all before hydrateRoot — all still leak one suspended render
// cycle. Static imports remove the Suspense boundary entirely. Vendor code
// (antd, framer-motion, lucide-react) is still code-split by CRA's default
// splitChunks config, so the bundle remains chunked by dependency rather than
// by route.

export const routes = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      {
        path: "store",
        children: [
          { index: true, element: <Store /> },
          { path: "website", element: <StoreAll /> },
          { path: "detail/:id", element: <Detail /> },
        ],
      },
      {
        path: "services",
        children: [
          { index: true, element: <WebsiteDesign /> },
          { path: "website-design", element: <WebsiteDesign /> },
        ],
      },
      { path: "about", element: <About /> },
      { path: "knowledge", element: <Knowledge /> },
      { path: "contact", element: <Contact /> },
    ],
  },
  { path: "preview/:id", element: <Preview /> },
  { path: "*", element: <NotFound /> },
];

const AllRoutes = () => {
  return useRoutes(routes);
};

export default AllRoutes;
